var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/Home.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Home = ({
  color = '#353B60',
  ...other
}) => /*#__PURE__*/_jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: [/*#__PURE__*/_jsx("rect", {
    width: "24",
    height: "24",
    rx: "4",
    fill: color
  }), /*#__PURE__*/_jsx("path", {
    d: "M17.3249 6.59721V9.86788L18.8689 11.2598C19.1352 11.488 18.9678 11.9216 18.6179 11.9216H17.3249V17.2459C17.3249 17.6642 16.9826 18.0065 16.5643 18.0065H14.2824C13.8641 18.0065 13.5218 17.6642 13.5218 17.2459V14.4428C13.5218 13.8905 13.0741 13.4428 12.5218 13.4428H11.4793C10.927 13.4428 10.4793 13.8905 10.4793 14.4428V17.2459C10.4793 17.6642 10.137 18.0065 9.71867 18.0065H7.43681C7.01847 18.0065 6.67619 17.6642 6.67619 17.2459V11.9216H5.38313C5.03325 11.9216 4.87352 11.488 5.13213 11.2598L11.4909 5.53234C11.78 5.27373 12.2211 5.27373 12.5102 5.53234L15.043 7.8142V6.59721C15.043 6.17887 15.3853 5.83659 15.8036 5.83659H16.5643C16.9826 5.83659 17.3249 6.17887 17.3249 6.59721Z",
    fill: "white"
  })]
});